import React, { useEffect } from "react";
import { gsap } from "gsap";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";

gsap.registerPlugin(MorphSVGPlugin);

MorphSVGPlugin.convertToPath("circle, rect, ellipse, line, polygon, polyline");

export const People = () => {
  useEffect(() => {
    gsap.set(".people-tick", {
      autoAlpha: 0,
    });
  }, []);

  const switchColour = () => {
    gsap.to(".people1", { stroke: "#fff" });
  };

  const revokeColour = () => {
    gsap.to(".people1", { stroke: "#DF6469" });
  };

  const toTick = () => {
    gsap.to(".people1", {
      morphSVG: ".people-tick",
    });
  };

  return (
    <svg
      id="prefix__Layer_1"
      x={0}
      y={0}
      viewBox="0 0 120.9 106"
      onMouseEnter={switchColour}
      onMouseLeave={revokeColour}
    >
      <path
        style={{
          fill: "none",
          stroke: "#DF6469",
          strokeWidth: 2,
          strokeLinecap: "round",
          strokeLineJoin: "round",
        }}
        className="people1"
        d="M37 24.3C38.5 10.1 50.2-.3 63.2 1.1s22.3 14 20.7 28.2-13.2 24.6-26.2 23.2S35.4 38.4 37 24.3z"
      />
      <path
        style={{
          fill: "none",
          stroke: "#DF6469",
          strokeWidth: 2,
          strokeLinecap: "round",
          strokeLineJoin: "round",
        }}
        className="people1"
        d="M54.4 15.8c.9-4.6 5-7.7 9.1-6.9s6.8 5.2 5.9 9.8-5 7.7-9.1 6.9-6.8-5.1-5.9-9.8zM39.1 37c2.5-5.9 7.6-10.4 13.9-12 2.5 4.5 8.2 6.2 12.8 3.6.8-.4 1.5-.9 2.1-1.6 6 2.5 10.6 7.5 12.4 13.7M47.8 34.6c-2.6 2.4-4.4 5.5-5 9M69.9 35.6c3.5 2.4 5.6 6.3 5.4 10.6M1.7 74.2c3.1-13.9 15.9-22.9 28.6-20.1s20.6 16.4 17.5 30.3-15.9 22.9-28.6 20.1S-1.4 88.1 1.7 74.2z"
      />
      <path
        style={{
          fill: "none",
          stroke: "#DF6469",
          strokeWidth: 2,
          strokeLinecap: "round",
          strokeLineJoin: "round",
        }}
        className="people1"
        d="M19.9 67.7c1.4-4.5 5.8-7.1 9.8-5.9s6.2 5.9 4.8 10.4-5.8 7.1-9.8 5.9-6.2-5.9-4.8-10.4zM2.5 87.1c3.1-5.6 8.7-9.5 15.1-10.4 2 4.8 7.5 7 12.3 5 .8-.3 1.5-.8 2.2-1.3 5.7 3.1 9.7 8.6 10.9 15M11.3 85.7c-2.9 2.1-5 5-6 8.4M33.2 89c3.2 2.7 4.8 6.9 4.2 11.1M73 74c2.5-14 15-23.5 27.8-21.2s21.2 15.5 18.6 29.6-15 23.5-27.8 21.2S70.4 88 73 74z"
      />
      <path
        className="people1"
        style={{
          fill: "none",
          stroke: "#DF6469",
          strokeWidth: 2,
          strokeLinecap: "round",
          strokeLineJoin: "round",
        }}
        d="M91.4 66.6c1.4-4.5 5.8-7.1 9.8-5.9s6.2 5.9 4.8 10.4-5.8 7.2-9.8 5.9-6.2-5.9-4.8-10.4zM73.9 86c3.1-5.6 8.7-9.5 15.1-10.4 1.2 2.7 3.5 4.7 6.3 5.4 2.9.7 5.9 0 8.2-1.8 5.7 3.1 9.7 8.6 10.9 15M82.8 84.6c-2.9 2.1-5 5-6 8.4M104.6 88c3.2 2.7 4.8 6.9 4.2 11.1M59.1 53.1v12M47.3 70.4c4-1.8 8.1-3.5 12.2-4.8l14.1 5.7"
      />

      <path
        d="M105.7 31.7L94 19.1 46.3 65.7 28.1 45.2 15.2 56.5 39.5 84c1 1.2 2.4 1.9 3.8 2.4s2.9.5 4.5.2c1.4-.5 2.9-1.2 3.8-2.4l54.1-52.5h0z"
        fill="none"
        stroke="#DF6469"
        strokeWidth={2}
        strokeLinejoin="round"
        strokeMiterlimit={10}
        className="people-tick"
      />
    </svg>
  );
};

export const Trolley = () => {
  useEffect(() => {
    gsap.set(".trolley-tick", {
      autoAlpha: 0,
    });
  }, []);

  const switchColour = () => {
    gsap.to("#trolley1", { stroke: "#fff" });
  };

  const revokeColour = () => {
    gsap.to("#trolley1", { stroke: "#DF6469" });
  };

  const toTick = () => {
    gsap.to(".trolley-main", { morphSVG: ".trolley-tick" });
  };

  return (
    <svg
      viewBox="0 0 95.69 82.87"
      // onMouseEnter={switchColour}
      // onMouseLeave={revokeColour}
    >
      <g
        fill="none"
        stroke="#DF6469"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path
          className="trolley-main"
          id="trolley1"
          d="M28.82 58.55H87.3M28.83 58.36C22 39.1 15.16 19.84 7.74 1L1 1.66M22.5 70.33c1.57-4.87 6.18-7.75 10.29-6.42s6.21 6.35 4.62 11.22-6.18 7.75-10.3 6.42-6.18-6.35-4.61-11.22zM71.87 70.33c1.57-4.87 6.18-7.75 10.3-6.42s6.18 6.35 4.61 11.22-6.18 7.75-10.3 6.42-6.18-6.35-4.61-11.22zM35.11 57.87C31.6 45.46 22.36 20 22.36 20l71.84.63M81.82 58.36l12.87-37.43M79.29 21.26L69.93 58M42.21 20.87q3.49 18.45 7 36.92M26.37 29.68l64.85.08M31.91 43.71h53.7"
        />
      </g>

      <path
        d="M93.4 21L81.7 8.4 34 55 15.8 34.5 2.9 45.8l24.3 27.5c1 1.2 2.4 1.9 3.8 2.4s2.9.5 4.5.2c1.4-.5 2.9-1.2 3.8-2.4L93.4 21h0z"
        fill="none"
        stroke="#DF6469"
        strokeWidth={2}
        strokeLinejoin="round"
        strokeMiterlimit={10}
        className="trolley-tick"
      />
    </svg>
  );
};

export const Hand = () => {
  const switchColour = () => {
    gsap.to(".hand1", { stroke: "#fff" });
  };

  const revokeColour = () => {
    gsap.to(".hand1", { stroke: "#DF6469" });
  };

  return (
    <svg
      viewBox="0 0 100.76 102.73"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={switchColour}
      onMouseLeave={revokeColour}
    >
      <g
        fill="none"
        stroke="#DF6469"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path
          className="hand1"
          d="M57.7 46.18c10-3.66 16.59-14.83 15-25.34S61.53 1.6 50.92 1s-21.1 7.1-23.8 17.38 2.67 22.09 12.8 27A9.24 9.24 0 0053.7 55.74a9.06 9.06 0 004-9.56zM39.34 45.06a25.47 25.47 0 0019.25.76M39.87 48.36a18.28 18.28 0 0018 .39M40.92 52.34a20.34 20.34 0 0015.59.16M81.69 27.5l7.28.13M81.5 17.79L88.09 14M81.64 37l4.76 4.16M15.7 27.5l-7.28.13M15.89 17.79L9.3 14M15.75 37L11 41.16"
        />
        <rect
          className="hand1"
          height={34.19}
          rx={2}
          width={15.61}
          x={1}
          y={63.73}
        />
        <path
          className="hand1"
          d="M16.53 96.83c14.63 6.22 30.76 6.26 45.94 1.55a71.25 71.25 0 0036.65-27 3.54 3.54 0 00.14-3.85A8.08 8.08 0 0089 64.2a69.21 69.21 0 00-19.13 12.59"
        />
        <path
          className="hand1"
          d="M67.1 71.85l16.53-12.09A4 4 0 0190 63.81M61.35 69.73l15.21-10.6a2.94 2.94 0 013.15-.1c.94.58 1 1.74.81 2.84M55.4 69.42l11.8-8.71a2.58 2.58 0 014.1 1.7"
        />
        <path
          className="hand1"
          d="M16.71 71.54a17.27 17.27 0 0111.91-8.05 17.49 17.49 0 0113.89 4.08c2.36 2.06 5.69 2.61 8.82 2.58s6.27-.56 9.39-.27 6.37 1.57 8 4.25.8 6.86-2.14 7.94a51.85 51.85 0 01-26.3 2.46M5.42 64l-.86 33.48M39.78 10.67c-6.57 3.82-9.4 13-6 19.77M45.75 32.8a3.92 3.92 0 007.84 0M44.17 46.54l-2.92-13a1.62 1.62 0 00-1.88-1.13 1.6 1.6 0 00-1.11 2.31 3.91 3.91 0 003.4 2 4.07 4.07 0 004.09-3.92M55.19 46.54l2.92-13A1.63 1.63 0 0160 32.45a1.6 1.6 0 011.11 2.31 3.93 3.93 0 01-3.4 2 4.09 4.09 0 01-4.12-3.92"
        />
      </g>
    </svg>
  );
};

export const Puzzle = () => {
  const switchColour = () => {
    gsap.to(".puzzle1", { stroke: "#fff" });
  };

  const revokeColour = () => {
    gsap.to(".puzzle1", { stroke: "#DF6469" });
  };

  return (
    <svg
      viewBox="0 0 112.39 108.33"
      onMouseEnter={switchColour}
      onMouseLeave={revokeColour}
    >
      <g
        fill="none"
        stroke="#DF6469"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path
          className="puzzle1"
          d="M36.72 21.74l-14.38 7.73c.61-4.48-5-8.42-9-6.34s-4 8.94 0 11C9.17 37.09 5 40 1 43.45q3.42 6.24 6.82 12.49c.9-4.83 8.59-6.38 11.29-2.28s-1.78 10.56-6.57 9.46l9.28 13.78 11.5-9.74c1.12 4.68 7.22 7.34 11.41 5s5.05-9 1.62-12.33q6-4.05 12-8.07l-7.44-10.9c-1.3 3.92-7.65 4.69-9.84 1.19s1.24-8.87 5.33-8.35c-3.23-4.12-6.47-8.24-9.68-11.96z"
        />
        <path
          className="puzzle1"
          d="M22.13 78l8.81 9.3c-4.76.38-7.62 7-4.63 10.74s10.08 2.37 11.49-2.2L48 107.33l12.93-7.17c-4.62-.17-7.28-6.94-4-10.21s10-.59 10.2 4l13.67-8.63-8.97-11.12c5.32.4 9.15-7.15 5.68-11.2s-11.51-1.46-12 3.86l-8.72-12M38.81 21L51 12.14a6.67 6.67 0 009.1 4.69 6.67 6.67 0 001.81-10.09L72.42 1q3.8 6.4 7.58 12.82c2.42-3.55 8.67-3.29 10.8.45s-.85 9.24-5.15 9.51q2.35 5.37 4.74 10.75l-10.88 6.55c.79-4.72-5.41-8.89-9.48-6.36s-3.1 9.93 1.48 11.28l-11.77 6.61M81.29 84.93l9.57-7.61c.84 4 6.27 6.26 9.69 4s3.47-8.15.08-10.47l10.76-8.15-7.93-9c-1.11 4-7.34 5.08-9.76 1.76s.54-8.91 4.65-8.76l-7.78-11.48"
        />
      </g>
    </svg>
  );
};

export const Cloud = () => {
  const switchColour = () => {
    gsap.to("#cloud1", { stroke: "#fff" });
  };

  const revokeColour = () => {
    gsap.to("#cloud1", { stroke: "#DF6469" });
  };

  return (
    <svg
      viewBox="0 0 99.15 44.12"
      onMouseEnter={switchColour}
      onMouseLeave={revokeColour}
    >
      <path
        d="M90.1 42a37 37 0 01-10.33 1.1c-25.08-.65-46-.89-71.32-1.56-5.17-.14-9.06-7.45-6.79-12.77s9.71-6.3 13-1.71c-.66-8.43 8.41-15.59 15.05-11.84-.28-5.81 3.66-11.49 8.67-12.5s10.41 2.8 14.07 10.13C54.32 4.06 63.79-1.42 71.09 2.06s10.58 15 6.44 22.73a5.3 5.3 0 018.23-.34 7.3 7.3 0 01-.51 9.4c3.15-3.68 10.12-4.89 12.26-.6 2.49 4.94-2.59 7.48-7.41 8.75z"
        fill="none"
        stroke="#DF6469"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        id="cloud1"
      />
    </svg>
  );
};

export const Info = () => {
  const switchColour = () => {
    gsap.to(".info1", { stroke: "#fff" });
  };

  const revokeColour = () => {
    gsap.to(".info1", { stroke: "#DF6469" });
  };

  return (
    <svg
      viewBox="0 0 88 59.34"
      onMouseEnter={switchColour}
      onMouseLeave={revokeColour}
    >
      <g
        fill="none"
        stroke="#DF6469"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path className="info1" d="M1 1h86v57.34H1z" />
        <path
          className="info1"
          d="M1 1.58h86v9.79H1zM38.66 22.63h39.18M38.66 32.88h39.18M38.66 43.88h39.18M15 25.05a3.75 3.75 0 113.55 3.82A3.68 3.68 0 0115 25.05zM28.08 44.75a14.52 14.52 0 00-3.91-14.3c-2.47 1.73-6.93 1.95-10.45.45a14.51 14.51 0 00-2.85 14c5.83.47 11.65.91 17.21-.15z"
        />
      </g>
    </svg>
  );
};

export const Tick = () => {
  useEffect(() => {
    gsap.set(".after-tick1", { autoAlpha: 0 });
  }, []);

  const hoverColour = () => {
    toTick();
    gsap.to(".tick1", { stroke: "#fff" });
  };

  const revokeColour = () => {
    gsap.to(".tick1", { stroke: "#C9317F" });
  };

  const toTick = () => {
    gsap.to(".tick1", {
      morphSVG: ".after-tick1",
    });
  };

  return (
    <svg
      viewBox="0 0 33.3 25.2"
      // onClick={toTick}
      onMouseEnter={hoverColour}
      onMouseLeave={revokeColour}
    >
      <path
        d="M32.6 5.1L28.5.7 11.6 17.1 5.2 9.8l-4.6 4 8.6 9.7c.3.4.8.7 1.3.9.5.2 1 .2 1.6.1.5-.2 1-.4 1.3-.9L32.6 5.1h0z"
        fill="none"
        stroke="#C9317F"
        strokeWidth={0.6}
        strokeLinejoin="round"
        strokeMiterlimit={10}
        className="tick1"
      />

      <path
        d="M5.7 14.1c0-5.9 4.7-10.6 10.6-10.6s10.6 4.7 10.6 10.6-4.7 10.6-10.6 10.6S5.7 19.9 5.7 14.1zm8.1-6.2c3.4-1.4 7.2.2 8.6 3.6s-.2 7.2-3.6 8.6-7.2-.2-8.6-3.6.2-7.2 3.6-8.6zm2.5 5.5c.4 0 .6.3.6.6s-.3.6-.6.6-.6-.3-.6-.6.2-.6.6-.6zm.1-.1l1.2-3.5m-.4 4.7l3.1 1.4M16.4 5.4c0-.2.1-.3.3-.3.2 0 .3.1.3.3s-.1.3-.3.3h0c-.1 0-.3-.1-.3-.3zm8.3 8.7c0-.2.1-.3.3-.3s.3.1.3.3c0 .2-.1.3-.3.3h0c-.1-.1-.3-.2-.3-.3zm-8.6 8.6c0-.2.1-.3.3-.3.2 0 .3.1.3.3 0 .2-.1.3-.3.3-.1 0-.3-.2-.3-.3zm-8.9-8.9c0-.2.1-.3.3-.3s.3.1.3.3c0 .2-.1.3-.3.3h0c-.2 0-.3-.2-.3-.3zm6-9.9c0-1.8 1.4-3.2 3.2-3.3 1.8 0 3.2 1.4 3.3 3.2M7 5.7L8.2 7m-2.8-.2l2.8-2.6m17.4 1.3l-1.3 1.3m2.9-.2L24.4 4"
        fill="none"
        stroke="#C9317F"
        strokeMiterlimit={10}
        className="after-tick1"
      />
    </svg>
  );
};

export const Tick2 = () => {
  useEffect(() => {
    gsap.set(".after-tick2", { autoAlpha: 0 });
  }, []);

  const hoverColour = () => {
    toTick();
    gsap.to(".tick2", { stroke: "#fff" });
  };

  const revokeColour = () => {
    gsap.to(".tick2", { stroke: "#C9317F" });
  };

  const toTick = () => {
    gsap.to(".tick2", {
      morphSVG: ".after-tick2",
    });
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 33.3 25.2"
      // onClick={toTick}
      onMouseEnter={hoverColour}
      onMouseLeave={revokeColour}
    >
      <path
        d="M32.6 5.1L28.5.7 11.6 17.1 5.2 9.8l-4.6 4 8.6 9.7c.3.4.8.7 1.3.9.5.2 1 .2 1.6.1.5-.2 1-.4 1.3-.9L32.6 5.1h0z"
        fill="none"
        stroke="#C9317F"
        strokeWidth={0.6}
        strokeLinejoin="round"
        strokeMiterlimit={10}
        className="tick2"
      />
      {/* <path
        d="M20.1 8.7c1.5-1.9 5-1.8 7.9.4s4 5.5 2.6 7.4c-1.4 1.9-5 1.8-7.9-.4s-4-5.5-2.6-7.4zm-1.8 3.6c.6 4.5 5.4 7.1 8.3 7.1m-8.3-7.1c.1-1.7 1.4-4 3.2-4.6m5.2 11.7c1.2 0 2.7-.6 4-3m-6.3-6.6c-.9 0-1.7.8-1.6 1.8 0 .9.8 1.7 1.8 1.6.4 0 .9-.2 1.2-.5.7-.6 1.7-.6 2.3 0 .6.7.6 1.7 0 2.3-.3.3-.8.5-1.2.5m1.2-.5c.2.1.4.3.6.4m-5.8-4.8l-.7-.5M5.4 17.6c-.9 2 .7 4.6 3.6 5.9 2.9 1.3 6 .8 6.9-1.1.9-2-.7-4.6-3.6-5.9s-6-.9-6.9 1.1zm2-2.9c3.7-1.4 7.8 1.2 9.1 3.5m-9.1-3.5c-1.3.8-2.6 2.8-2.3 4.4m11.4-1c.5.9.6 2.3-.7 4.4m-7.7-2c-.3-.6-.1-1.3.3-1.8.5-.4 1.2-.5 1.8-.2.6.4.8 1.1.6 1.7-.2.8.2 1.6 1 1.8.5.2 1.1 0 1.4-.4.5-.5.6-1.2.2-1.8m.9 1.6l-.6-.3m-6.3-2.5l.6.3M5.2 7.6c-.7-2 1.1-4.4 4.1-5.5s5.9-.3 6.6 1.7-1.1 4.4-4.1 5.5-5.9.2-6.6-1.7zm1.7 3c3.5 1.7 7.7-.4 9.1-2.6m-9.1 2.6c-1.2-.9-2.3-3-1.8-4.5M16 8c.6-.9.8-2.2-.3-4.3M8 5c-.3.5-.2 1.3.2 1.8.5.4 1.2.6 1.8.3.6-.3.9-1 .8-1.6-.2-.8.3-1.5 1.1-1.7.5-.1 1 .1 1.4.5.4.5.4 1.2.1 1.7m.7-1.4l-.6.2M7.2 6.7l.7-.3"
        fill="none"
        stroke="#C9317F"
        strokeMiterlimit={10}
        strokeWidth={0.75}
        className="after-tick2"
      /> */}
      <path
        style={{
          fill: "none",
          stroke: "#c9317f",
          strokeMiterlimit: 10,
        }}
        className="after-tick2"
        d="M28.4 24.1H5.9V3.7m-1.2.8 1.2-.7 1.2.7-1.2-2.9-1.2 2.9zM5.9 24.1s13.8-4.7 16.8-22.4"
      />
    </svg>
  );
};

export const Tick3 = () => {
  useEffect(() => {
    gsap.set(".after-tick3", { autoAlpha: 0 });
  }, []);

  const hoverColour = () => {
    toTick();
    gsap.to(".tick3", { stroke: "#fff" });
  };

  const revokeColour = () => {
    gsap.to(".tick3", { stroke: "#C9317F" });
  };

  const toTick = () => {
    gsap.to(".tick3", {
      morphSVG: ".after-tick3",
    });
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 33.3 25.2"
      // onClick={toTick}
      onMouseEnter={hoverColour}
      onMouseLeave={revokeColour}
    >
      <path
        d="M32.6 5.1L28.5.7 11.6 17.1 5.2 9.8l-4.6 4 8.6 9.7c.3.4.8.7 1.3.9.5.2 1 .2 1.6.1.5-.2 1-.4 1.3-.9L32.6 5.1h0z"
        fill="none"
        stroke="#C9317F"
        strokeWidth={0.6}
        strokeLinejoin="round"
        strokeMiterlimit={10}
        className="tick3"
      />
      {/* <path
        d="M11.1 6.3c.3-3.2 3-5.6 5.9-5.2s5 3.2 4.7 6.4-3 5.6-5.9 5.2c-3-.4-5.1-3.3-4.7-6.4zm3.9-2c.2-1 1.1-1.7 2.1-1.6S18.6 4 18.4 5s-1.1 1.7-2.1 1.6c-.9-.2-1.5-1.2-1.3-2.3zm-3.4 4.8c.6-1.3 1.7-2.3 3.1-2.7.6 1 1.9 1.4 2.9.8.2-.1.4-.2.5-.3 1.4.6 2.4 1.7 2.8 3.1m-7.4-1.4c-.6.5-1 1.2-1.1 2m6.1-1.8c.8.5 1.3 1.4 1.2 2.4M3.1 17.5c.7-3.1 3.6-5.2 6.5-4.5 2.9.6 4.7 3.7 4 6.8-.8 3.2-3.6 5.2-6.5 4.6s-4.7-3.7-4-6.9zm4.1-1.4c.3-1 1.3-1.6 2.2-1.3.9.3 1.4 1.3 1.1 2.3s-1.3 1.6-2.2 1.3-1.4-1.3-1.1-2.3zm-3.9 4.3c.7-1.3 2-2.1 3.4-2.3.5 1.1 1.7 1.6 2.8 1.1.2-.1.3-.2.5-.3 1.3.7 2.2 1.9 2.5 3.4m-7.2-2.2c-.7.5-1.1 1.1-1.4 1.9m6.4-1.1c.7.6 1.1 1.6.9 2.5m8-5.9c.6-3.2 3.4-5.3 6.3-4.8s4.8 3.5 4.2 6.7-3.4 5.3-6.3 4.8c-2.8-.5-4.7-3.5-4.2-6.7zm4.2-1.7c.3-1 1.3-1.6 2.2-1.3.9.3 1.4 1.3 1.1 2.3-.3 1-1.3 1.6-2.2 1.3-.9-.2-1.4-1.3-1.1-2.3zm-4 4.4c.7-1.3 2-2.1 3.4-2.3.3.6.8 1.1 1.4 1.2.7.2 1.3 0 1.9-.4 1.3.7 2.2 1.9 2.5 3.4m-7.1-2.2c-.7.5-1.1 1.1-1.4 1.9m6.3-1.1c.7.6 1.1 1.6.9 2.5M16.1 12.8v2.7m-2.7 1.2c.9-.4 1.8-.8 2.8-1.1l3.2 1.3"
        fill="none"
        stroke="#C9317F"
        strokeMiterlimit={10}
        className="after-tick3"
      /> */}
      <path
        style={{
          fill: "none",
          stroke: "#C9317F",
          strokeWidth: 0.6,
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
        className="after-tick3"
        d="M11 6c.3-3.2 3-5.6 6-5.3s5.1 3.2 4.7 6.4-3 5.6-6 5.3c-2.9-.3-5-3.2-4.7-6.4zM3 17.4c.7-3.2 3.6-5.2 6.5-4.6 2.9.6 4.7 3.7 4 6.9-.7 3.2-3.6 5.3-6.5 4.6-2.9-.6-4.7-3.7-4-6.9zm16.3 0c.6-3.2 3.4-5.4 6.4-4.8s4.8 3.5 4.3 6.8c-.6 3.2-3.4 5.4-6.4 4.8-3-.6-4.9-3.6-4.3-6.8zm-3.2-4.8v2.7m-2.7 1.3c.9-.4 1.9-.8 2.8-1.1l3.2 1.3m-3.3-7.6h.7c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2h-.7c-.1 0-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1.7-5c-.8-.5-1.9-.6-2.8-.1-.8.5-1.4 1.3-1.3 2.3-.3 0-.5-.1-.8-.2 0 .9.1 1.9.1 2.8.2.2.7 0 .7-.3V6.4m5.1 1.3c0 .4-.2.8-.5 1.2-.3.3-.8.5-1.3.6m1.2-5.8c-1-.7-2.3-.8-3.4-.2C13.7 4 13 5.2 13 6.2c-.7.1-1.3.9-1.2 1.6.1.7.8 1.3 1.5 1.3m1.5-4.9c.8-.6 1.9-.6 2.8-.1.8.5 1.3 1.3 1.2 2.3.3 0 .6-.1.8-.1 0 .9-.1 1.9-.1 2.8-.2.2-.7 0-.7-.3V6.5m-.6-2.8c-1-.7-2.3-.8-3.4-.2C13.7 4 13 5.2 13 6.2c-.7.1-1.3.9-1.2 1.6.1.7.8 1.3 1.5 1.3m1.2-5.4c1-.7 2.3-.8 3.4-.2 1.1.6 1.7 1.7 1.7 2.8.7.1 1.3.9 1.2 1.6-.1.7-.8 1.3-1.5 1.3m-7-2c-.2.3-.2.7.1.9m7.8-.9c.3.3.3.7.1.9m-2.1-4.4-.4.5m-3.3-.4c.1.1.2.3.3.4M4.1 19.3c.1-1.2 1-2.3 2.2-2.5 1.2-.2 2.4.5 2.9 1.7.3.7 0 1.4-.6 1.9-.5.5-1.3.6-2 .5s-1.3-.4-1.9-.7c-.3.3-.7.4-1.1.4.4-.3.5-.8.5-1.3zm3.1-2.7c.6-.8 1.6-1.1 2.5-1 1 .2 1.7.8 2.1 1.7.3.9.1 1.9-.5 2.7.1.4.4.8.9.9-.5.2-1.2 0-1.6-.4-.6.5-1.4.6-2.1.3m20.3-3.1c-.5 1.3-1 2.8-1.4 4.2 0 .1-5.7-.1-5.7-.1-.6-1.4-1.3-4.2-1.3-4.2s8.3 0 8.4.1zM22.5 15l-1.2 2.4m5.1-2.3c.4.8.8 1.7 1.2 2.5m-4.2-3v.7l2.2-.1v-.8c-.8.1-1.5.2-2.2.2zm-.8.4h.8m2.3 0h.7m-1.7 4.1v2m2.4-2-.5 2m-4.5-2 .4 2m-2-2.9h8.1"
      />
      )
    </svg>
  );
};

export const Tick4 = () => {
  useEffect(() => {
    gsap.set(".after-tick4", { autoAlpha: 0 });
  }, []);

  const hoverColour = () => {
    toTick();
    gsap.to(".tick4", { stroke: "#fff" });
  };

  const revokeColour = () => {
    gsap.to(".tick4", { stroke: "#C9317F" });
  };

  const toTick = () => {
    gsap.to(".tick4", {
      morphSVG: ".after-tick4",
    });
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 33.3 25.2"
      // onClick={toTick}
      onMouseEnter={hoverColour}
      onMouseLeave={revokeColour}
    >
      <path
        d="M32.6 5.1L28.5.7 11.6 17.1 5.2 9.8l-4.6 4 8.6 9.7c.3.4.8.7 1.3.9.5.2 1 .2 1.6.1.5-.2 1-.4 1.3-.9L32.6 5.1h0z"
        fill="none"
        stroke="#C9317F"
        strokeWidth={0.6}
        strokeLinejoin="round"
        strokeMiterlimit={10}
        className="tick4"
      />
      {/* <path
        d="M18.3 11.2c2.3-.9 3.9-3.5 3.5-5.9-.4-2.4-2.6-4.5-5.1-4.6s-4.9 1.7-5.5 4 .6 5.1 3 6.3c-.3 1.1.3 2.3 1.5 2.7.6.2 1.2.1 1.7-.2.7-.6 1-1.5.9-2.3zm-4.3-.3c1.4.6 3 .7 4.5.2m-4.4.6c1.3.8 2.9.8 4.2.1m-3.9.8c1.2.5 2.5.5 3.6 0m5.8-5.8h1.7m-1.7-2.2l1.5-.9M23.8 9l1.1 1M8.5 6.8H6.8m1.7-2.2L7 3.7M8.5 9l-1.1 1m-1.9 5.3h2.7c.3 0 .5.2.5.5v7c0 .3-.2.5-.5.5H5.5c-.3 0-.5-.2-.5-.5v-7c.1-.3.3-.5.5-.5zM8.7 23c3.4 1.4 7.2 1.5 10.7.4 3.5-1.1 6.5-3.3 8.5-6.3.2-.3.2-.6 0-.9-.5-.8-1.5-1.2-2.4-.8-1.6.7-3.1 1.7-4.5 2.9m-.6-1.1l3.8-2.8c.4-.3 1-.2 1.3.2.2.2.2.5.2.8m-6.6 1.3l3.5-2.5c.2-.1.5-.2.7 0 .2.1.2.4.2.7m-5.8 1.7l2.7-2c.3-.2.6-.1.8.1.1.1.1.2.1.3M8.7 17.1c.6-1 1.6-1.7 2.8-1.9 1.2-.2 2.3.2 3.2.9.5.5 1.3.6 2.1.6.7 0 1.5-.1 2.2-.1.7.1 1.5.4 1.9 1 .4.6.2 1.6-.5 1.8-2 .7-4.1.9-6.1.6m-8.2-4.7l-.2 7.8m8.2-20.2c-1.5.9-2.2 3-1.4 4.6m2.8.6c0 .5.4.9.9.9s.9-.4.9-.9m-2.2 3.2l-.7-3c0-.3-.2-.4-.4-.3-.2 0-.3.2-.3.4v.1c.2.3.5.5.8.5.5 0 .9-.4 1-.9m2.2 3.2l.7-3c0-.3.2-.4.4-.3.2 0 .3.2.3.4v.1c-.2.3-.5.5-.8.5-.5 0-.9-.4-1-.9"
        fill="none"
        stroke="#C9317F"
        strokeMiterlimit={10}
        className="after-tick4"
      /> */}
      <path
        style={{
          fill: "none",
          stroke: "#C9317F",
          strokeMiterlimit: 10,
        }}
        className="after-tick4"
        d="M16.2 7.1c4.8 0 8.7 3.9 8.7 8.7s-3.9 8.7-8.7 8.7-8.7-3.9-8.7-8.7 3.9-8.7 8.7-8.7zm-6.7 8.6a6.7 6.7 0 1 1 13.4 0 6.7 6.7 0 0 1-13.4 0zm5.5-.8 1.4-3.1-.2 7m-1.8.2 3.5-.1m2.1-6.2c1.5 1.1 2 3 1.3 4.7m-.3.9-.7.9m.1-11.4C22 5.6 23.5 3.3 25.1 1m-7.5 6c.9-2 1.8-4 2.6-6.1L25 .8m-12.8 7L7.5 1M15 7c-.9-2-1.8-4-2.6-6.1L7.6.8"
      />
    </svg>
  );
};

export const Touch = () => {
  return (
    <svg viewBox="0 0 129.7 114.3">
      <path
        id="swipe-hand"
        d="M51.6 28.3c-1.2.9-1.9 2-2 3.2-.2 1.5.4 3.2 1.7 5.2.4.6.8 1.2 1.3 1.9 1.2 1.7 2.8 3.7 4.6 6.1.8 1.1 1.7 2.2 2.7 3.4l9.4 11.6c-.6.1-1.1.3-1.6.5-1.1.6-2 1.6-2.3 2.8-.4 1.1-.4 2-.4 2.9v1c0 .7-.2 1.8-.9 2.2-.4.2-.9.3-1.5.3-.5 0-1 .1-1.4.2-1.9.5-3.2 2.3-3.2 4.3 0 .7.2 1.4.4 2.1.1.5.2 1 .3 1.4.1 1.2-.4 2.4-1.2 3-.2 0-.5.2-.6.4-.4.2-.6.8-.4 1.2-1.5 7.5 7.6 15.2 14.9 21.5 3.6 3.1 7 5.9 8.2 8 .2.3.5.5.8.5.2 0 .3 0 .5-.1.4-.3.6-.8.3-1.3-1.4-2.4-4.7-5.2-8.6-8.5C65.5 96 56.7 88.5 58.4 82c1.5-1 2.3-2.9 2.1-4.9-.1-.6-.2-1.1-.3-1.7-.1-.6-.3-1.2-.3-1.7 0-1.2.7-2.2 1.8-2.5.3-.1.7-.1 1.1-.1.7-.1 1.6-.1 2.3-.6 1.1-.6 1.7-1.9 1.8-3.7v-1.1c0-.8 0-1.5.2-2.2.2-.7.7-1.3 1.4-1.7.8-.4 1.7-.5 2.5-.2H71.8c.1 0 .1-.1.2-.1l.1-.1v-.1s0-.1.1-.1c0-.1.1-.1.1-.2v-.2-.1-.1-.1-.1-.1-.1c0-.1-.1-.1-.1-.2L61.3 47.1c-.9-1.2-1.8-2.4-2.7-3.4-1.5-2-2.9-3.7-4-5.3-.4-.6-.8-1.1-1.2-1.7-1.4-2.1-2.2-3.8-2-5 .1-.7.5-1.3 1.3-2 1.4-1 3.7.8 6 3.3.4.5.9.9 1.3 1.4 1 1.1 1.9 2.3 2.7 3.3 1.2 1.5 2.4 2.9 3.4 4l11.6 14.6c.4.6.9 1.2 1.5 1.8L89.4 71c.2.2.5.4.7.4.2 0 .4-.1.6-.2.4-.3.5-.9.1-1.3L79.2 55.3c-1.1-1.7-1.6-3.3-1.4-4.2.1-.4.2-.5.4-.5 1-.4 1.7-.3 2.4.6 3.3 4 7.1 6.6 10.1 8.7 2.4 1.6 4.4 3 5.5 4.6l3.5 8.5c3.8 8.3 3.7 14.2 3.6 18.9-.1 3.3-.1 6.2 1.1 9.1.1.4.5.6.9.6.1 0 .2 0 .4-.1.5-.2.7-.7.5-1.2-1.1-2.5-1-5.2-1-8.3.1-4.9.2-11-3.8-19.7l-3.5-8.6c0-.1 0-.1-.1-.2-1.3-1.9-3.5-3.5-6.1-5.2-3.1-2.1-6.5-4.5-9.7-8.3-1.2-1.5-2.8-1.8-4.6-1.1-.8.3-1.3 1-1.5 1.9 0 .2-.1.3-.1.5l-8.4-10.6-.1-.1c-.9-1-2.1-2.4-3.3-3.9-1-1.3-2.1-2.6-3.2-3.8-.5-.5-.9-1.1-1.4-1.5-2.6-3-5.5-4.9-7.8-3.1z"
        fill="#fff"
      />
      <path
        d="M16.7 13.4l8.5 8.3c.4.4 1 .4 1.3 0 .4-.4.4-1 0-1.3l-6.9-6.8 22.5-.2v-1.9l-22.5.2 6.8-6.9c.4-.4.4-1 0-1.3-.2-.2-.4-.3-.7-.3-.2 0-.5.1-.7.3L16.7 12c-.4.4-.4 1 0 1.4zM90.8 11.7l-8.5-8.3c-.4-.4-1-.4-1.3 0-.4.4-.4 1 0 1.3l6.9 6.8-22.5.2v1.9l22.5-.2-6.8 6.9c-.4.4-.4 1 0 1.3.2.2.4.3.7.3.2 0 .5-.1.7-.3l8.3-8.5c.3-.4.3-1 0-1.4z"
        fill="#fff"
      />
    </svg>
  );
};

export const Reuse = () => {
  return (
    <svg viewBox="0 0 73.66 79.77">
      <g
        fill="none"
        stroke="#DF6469"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="m1.11 37.39 10.49.19M63.09 27.92l-6 1.91a17 17 0 0 1 9.61 8q3-5.94 5.92-11.9a28 28 0 0 0-4.7.66M11.28 36.94C9.84 23.7 19.9 10.21 33 7.82s27.27 6.69 30.25 19.82" />
        <path d="M67.92 26.48A34.29 34.29 0 0 0 46.23 2.77a34.31 34.31 0 0 0-31.7 5.29C5.73 14.94.14 26.27 1.11 37.39M72.55 42.38l-10.49-.19M10.57 51.85l5.95-1.91a17 17 0 0 1-9.6-8q-3 6-5.92 11.9a28 28 0 0 0 4.7-.66M62.37 42.83C63.82 56.08 53.76 69.56 40.66 72s-27.28-6.74-30.25-19.87" />
        <path d="M5.73 53.29A34.3 34.3 0 0 0 27.43 77a34.29 34.29 0 0 0 31.69-5.29c8.8-6.88 14.4-18.21 13.43-29.33" />
      </g>
    </svg>
  );
};

export const Omni = () => {
  return (
    <svg
      id="Layer_1"
      x={0}
      y={0}
      viewBox="0 0 120.9 106"
      style={{
        enableBackground: "new 0 0 120.9 106",
      }}
    >
      <style>
        {
          ".st0,.st1{fill:none;stroke:#DF6469;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.st1{stroke-width:1.8}"
        }
      </style>
      <path
        className="st0"
        d="M37 24.3C38.5 10.1 50.2-.3 63.2 1.1s22.3 14 20.7 28.2-13.2 24.6-26.2 23.2S35.4 38.4 37 24.3zM1.7 74.2c3.1-13.9 15.9-22.9 28.6-20.1s20.6 16.4 17.5 30.3-15.9 22.9-28.6 20.1S-1.4 88.1 1.7 74.2zM73 74c2.5-14 15-23.5 27.8-21.2s21.2 15.5 18.6 29.6-15 23.5-27.8 21.2S70.4 88 73 74zM59.1 53.1v12"
      />
      <path className="st0" d="M47.3 70.4c4-1.8 8.1-3.5 12.2-4.8l14.1 5.7" />
      <path
        className="st1"
        d="M59 38.4h3.1c.4 0 .7.3.7.7v.8c0 .4-.3.7-.7.7H59c-.4 0-.7-.3-.7-.7v-.8c0-.3.3-.7.7-.7zM66.6 16.5c-3.6-2.5-8.3-2.7-12.1-.6-3.7 2.1-6 5.9-5.6 10.1-1.2-.2-2.4-.5-3.6-.7.2 3.9.4 8.5.6 12.3 1 1 3.1.1 3.1-1.3.1-3.2-.1-6.9 0-10.1M71.1 31.7c.1 1.8-.7 3.7-2.1 5.1s-3.6 2.4-5.9 2.7"
      />
      <path
        className="st1"
        d="M68.2 14.1c-4.4-3-10.1-3.4-14.8-1-4.6 2.5-7.6 7.6-7.6 12.1-3.2.6-5.6 3.8-5.3 7 .3 3.2 3.3 5.9 6.5 5.9"
      />
      <path
        className="st1"
        d="M53.5 16.5c3.6-2.5 8.3-2.7 12.1-.6C69.3 18 71.4 21.8 71 26c1.2-.2 2.5-.4 3.7-.6-.2 3.9-.4 8.3-.6 12.2-1 1-3.1.1-3.1-1.3-.1-3.2.1-6.9 0-10.1"
      />
      <path
        className="st1"
        d="M68.2 14.1c-4.4-3-10.1-3.4-14.8-1-4.6 2.5-7.6 7.6-7.6 12.1-3.2.6-5.6 3.8-5.3 7 .3 3.2 3.3 5.9 6.5 5.9"
      />
      <path
        className="st1"
        d="M52 14.1c4.4-3 10.1-3.4 14.8-1 4.6 2.5 7.6 7.6 7.6 12.1 3.2.6 5.6 3.8 5.3 7-.3 3.2-3.3 5.9-6.5 5.9M42.6 29.5c-.9 1.3-.8 3 .4 4.1"
      />
      <path
        className="st1"
        d="M77.1 29.5c1.1 1.1 1.2 2.9.3 4.1M68.3 14.3l-1.7 2.3M52 14.4c.5.6 1 1.3 1.5 1.9M6.8 82.3c.3-5.2 4.5-10 9.7-10.8 5.2-.8 10.7 2.4 12.5 7.3 1.1 2.9-.1 6.3-2.5 8.2-2.3 2-5.6 2.6-8.6 2.3-3-.3-5.9-1.6-8.5-3.2-1.3 1.3-3.1 1.9-4.9 1.8 1.6-1.2 2.2-3.3 2.3-5.6z"
      />
      <path
        className="st1"
        d="M20.1 70.8c2.6-3.3 6.8-5 10.9-4.4 4.2.7 7.6 3.5 9.1 7.4 1.4 4 .6 8.4-2.1 11.6.4 1.9 1.9 3.4 3.8 3.8-2.4.7-5.1-.1-7-1.7-2.4 2.4-5.9 3-9 1.6M114.7 75.2c-2 5.9-4.2 12.4-6.2 18.3-.2.4-24.9-.3-24.9-.4-2.5-6.1-5.8-18.3-5.8-18.3s36.6 0 36.9.4zM87 63.6l-5.4 10.5M104.1 63.9c1.9 3.4 3.5 7.5 5.4 10.9M91 61.8c0 1.1-.1 2.2-.1 3.2l9.8-.5v-3.3c-3.3.3-6.5.5-9.7.6zM87.4 63.7l3.4-.1M101 63.8h3.1-.1M96.8 81.4v8.7M107.2 81.5l-2.1 8.6M85.6 81.4l1.7 8.7M78.5 77.5h35.4"
      />
    </svg>
  );
};

export const Collab = () => {
  return (
    <svg
      id="Layer_1"
      x={0}
      y={0}
      viewBox="0 0 244 245.7"
      style={{
        enableBackground: "new 0 0 244 245.7",
      }}
    >
      <style>
        {
          ".cb1{fill:none;stroke:#DF6469;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}"
        }
      </style>
      <path
        className="cb1"
        d="m154.9 84.8-1.4-1.4M145.5 75.6c.2.1.3.2.5.4l7.5 7.4M154.9 84.8l.1.1M89.1 160.9h0v.1M90.6 162.4l-1.5-1.4M161.8 91.7l29.2 29.1c.4.4.8.9 1.2 1.3M98.5 170.2l-7.9-7.8M98.5 170.2l11 10.9 6 6c2.2 2.2 4.7 4.1 7.3 5.7M82.2 154.1 53 125c-.4-.4-.8-.9-1.2-1.3M82.2 154.1l6.9 6.8M51.8 123.7C44.9 116.1 41 106.3 41 96.1L26.7 81.9M89.1 160.9v.1M90.6 162.4l7.5 7.4c.1.1.3.3.5.4M90.6 162.4l-1.5-1.4M77.9 36.7 89.3 48l6.4-.7c9-1 18 1.1 25.6 5.7M153.5 83.4l1.4 1.4M153.5 83.4l-8-7.8M121.2 53c2.6 1.6 5.1 3.5 7.3 5.7l6 6 11 10.9M163.3 93.1l-8.3-8.2-.1-.1M4 70.6l17.1 17 5.6-5.7M26.7 81.9l54-53.7-17-17M208.7 79l-11.4 11.3.7 6.3c1 9-1.1 17.9-5.8 25.4"
      />
      <path
        className="cb1"
        d="M163.2 28.1 149 42.2c-10.3 0-20.2 3.9-27.8 10.8M90.6 162.4s0 0 0 0M163.2 28.1l-5.7-5.7L176 4M163.2 28.1l54 53.7 18.5-18.4M153.5 83.4s0 0 0 0M35.4 166.8l11.4-11.3-.7-6.3c-1-9 1.1-17.9 5.8-25.4M122.8 192.8c-7.6 6.9-17.5 10.8-27.8 10.8l-14.2 14.1M80.8 217.7l-54-53.8-18.4 18.4"
      />
      <path
        className="cb1"
        d="m80.8 217.7 5.7 5.6-18.4 18.4M217.3 163.9l-14.2-14.1h0c0-10.9-4.3-21.3-12.1-29L146 76c-3.8-3.8-10-3.8-13.8 0l-.2.2c-4 3.9-4 10.3 0 14.2 9.6 9.6 25.6 25.5 25.6 25.5L119 77.4c-3.8-3.8-10-3.8-13.8 0l-.2.2c-4 3.9-4 10.2-.1 14.2 11.4 11.4 32.7 32.5 32.7 32.5L99.3 86.1c-3.9-3.9-10.3-3.9-14.2 0h0c-3.9 3.9-3.9 10.2 0 14.1l38.4 38.2-32.9-32.7c-3.8-3.8-10-3.8-13.8 0l-.2.2c-4 3.9-4 10.3 0 14.2 15.2 15.2 49.8 49.5 49.8 49.5l-20.9-20.8c-4.2-4.2-10.9-4.2-15.1 0L89 150c-3 3-3 7.9 0 10.9l20.4 20.1 6 6c8.6 8.6 20.7 12.8 32.9 11.5l6.4-.7 11.4 11.3"
      />
      <path className="cb1" d="m180.3 234.6-17-17 59.7-59.4 17 17" />
    </svg>
  );
};

export const Medal = () => {
  return (
    <svg viewBox="0 0 70.87 94.51">
      <g
        fill="none"
        stroke="#DF6469"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <circle cx={35} cy={59.51} r={34} />
        <path d="M8.83 59.51A26.17 26.17 0 1 1 35 85.68 26.17 26.17 0 0 1 8.83 59.51z" />
        <path d="M30.51 56 36 43.83l-.93 27.49M27.94 72.15l13.62-.42M49.72 47.63a15.53 15.53 0 0 1 5 18.43M53.77 69.36l-2.89 3.48M51.4 28.54Q60.64 15.13 69.87 1.7M40.53 25.39c3.46-7.93 6.91-15.86 10-23.91l19-.48M19.46 28.54 1 1.7M30.34 25.39c-3.46-7.93-6.91-15.86-10-23.91L1.29 1" />
      </g>
    </svg>
  );
};

export const Target = () => {
  return (
    <svg viewBox="0 0 74.86 78.68">
      <g
        fill="none"
        stroke="#DF6469"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M63.8 26.9a30.12 30.12 0 0 1 6.93 20.65c-.89 17.59-17.22 31.06-36.46 30.08S.15 61.61 1 44s17.25-31 36.5-30a38.11 38.11 0 0 1 7 1" />
        <path d="M54.87 31.49a21.24 21.24 0 0 1 5.62 14.3c0 12.42-11 22.48-24.61 22.48s-24.6-10.06-24.6-22.48 11-22.48 24.6-22.48a26.92 26.92 0 0 1 5 .45" />
        <path d="M47.05 36.71a12.88 12.88 0 0 1 3.72 8.53c.28 7.52-6.16 13.85-14.39 14.15S21.27 53.85 21 46.34s6.17-13.85 14.39-14.16a16.58 16.58 0 0 1 3 .17" />
        <path d="M38 42.92c5.32-12 12.33-20.65 22.67-28.77" />
        <path d="M48.81 25.31a34.9 34.9 0 0 1 9.52-23.8c1.19-1.24 3.74-.05 3.55 1.65l-1.23 11.06M49.1 25.61l23.76-6.05a1.6 1.6 0 0 0 .22-2.86 27.28 27.28 0 0 0-12.49-2.11M37.92 43.43a4.16 4.16 0 1 0 1.35 6 4.23 4.23 0 0 0-1.35-6z" />
      </g>
    </svg>
  );
};
